<template>
  <div class="footer">
    Apertura
  </div>
</template>

<script setup>

</script>

<style scoped>
.footer {
  height: 7rem;
  background-color: black;
}
</style>